import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';

@Component({
  selector: 'icon-forward',
  standalone: true,
  template: `
    <button type="button" class="btn-forward" (click)="playClick()" aria-label="Forward">

      @if(state === 'idle'){
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M11.5 20.5V19H14V18H12.5V17H14V16H11.5V14.5H14.5C14.7833 14.5 15.0208 14.5958 15.2125 14.7875C15.4042 14.9792 15.5 15.2167 15.5 15.5V19.5C15.5 19.7833 15.4042 20.0208 15.2125 20.2125C15.0208 20.4042 14.7833 20.5 14.5 20.5H11.5ZM17.5 20.5C17.2167 20.5 16.9792 20.4042 16.7875 20.2125C16.5958 20.0208 16.5 19.7833 16.5 19.5V15.5C16.5 15.2167 16.5958 14.9792 16.7875 14.7875C16.9792 14.5958 17.2167 14.5 17.5 14.5H19.5C19.7833 14.5 20.0208 14.5958 20.2125 14.7875C20.4042 14.9792 20.5 15.2167 20.5 15.5V19.5C20.5 19.7833 20.4042 20.0208 20.2125 20.2125C20.0208 20.4042 19.7833 20.5 19.5 20.5H17.5ZM18 19H19V16H18V19ZM16 26.5C14.75 26.5 13.5792 26.2625 12.4875 25.7875C11.3958 25.3125 10.4458 24.6708 9.6375 23.8625C8.82917 23.0542 8.1875 22.1042 7.7125 21.0125C7.2375 19.9208 7 18.75 7 17.5C7 16.25 7.2375 15.0792 7.7125 13.9875C8.1875 12.8958 8.82917 11.9458 9.6375 11.1375C10.4458 10.3292 11.3958 9.6875 12.4875 9.2125C13.5792 8.7375 14.75 8.5 16 8.5H16.15L14.6 6.95L16 5.5L20 9.5L16 13.5L14.6 12.05L16.15 10.5H16C14.05 10.5 12.3958 11.1792 11.0375 12.5375C9.67917 13.8958 9 15.55 9 17.5C9 19.45 9.67917 21.1042 11.0375 22.4625C12.3958 23.8208 14.05 24.5 16 24.5C17.95 24.5 19.6042 23.8208 20.9625 22.4625C22.3208 21.1042 23 19.45 23 17.5H25C25 18.75 24.7625 19.9208 24.2875 21.0125C23.8125 22.1042 23.1708 23.0542 22.3625 23.8625C21.5542 24.6708 20.6042 25.3125 19.5125 25.7875C18.4208 26.2625 17.25 26.5 16 26.5Z" />
        </svg>
      }

      @if(state === 'active'){
        <svg @rotateOnEnter width="32" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_29_4088" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="25" height="24">
            <rect x="28.25" y="28" width="24" height="24" transform="rotate(-180 28.25 28)" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_29_4088)">
            <path d="M15.2 5.99995L15.2 8.04995C14.6333 8.13328 14.0791 8.28328 13.5375 8.49995C12.9958 8.71662 12.4833 8.99995 12 9.34995L10.6 7.89995C11.3 7.36662 12.0333 6.93745 12.8 6.61245C13.5666 6.28745 14.3666 6.08328 15.2 5.99995ZM17.2 5.99995C19.5 6.29995 21.4083 7.29578 22.925 8.98745C24.4416 10.6791 25.2 12.6666 25.2 14.95C25.2 16.2 24.9625 17.3708 24.4875 18.4625C24.0125 19.5541 23.3708 20.5041 22.5625 21.3125C21.7541 22.1208 20.8041 22.7625 19.7125 23.2375C18.6208 23.7125 17.45 23.95 16.2 23.95L16.05 23.95L17.6 25.5L16.2 26.95L12.2 22.95L16.2 18.95L17.6 20.35L16 21.95L16.2 21.95C18.15 21.95 19.8041 21.2708 21.1625 19.9125C22.5208 18.5541 23.2 16.9 23.2 14.95C23.2 13.2166 22.6333 11.6958 21.5 10.3875C20.3666 9.07912 18.9333 8.29995 17.2 8.04995L17.2 5.99995ZM9.14995 9.34995L10.6 10.7499C10.25 11.2333 9.96662 11.7458 9.74995 12.2874C9.53329 12.8291 9.38328 13.3833 9.29995 13.9499L7.24995 13.9499C7.33329 13.1166 7.53745 12.3166 7.86245 11.5499C8.18745 10.7833 8.61662 10.05 9.14995 9.34995ZM7.24995 15.9499L9.29995 15.9499C9.38328 16.5166 9.53329 17.0708 9.74995 17.6124C9.96662 18.1541 10.25 18.6666 10.6 19.1499L9.14995 20.5499C8.61662 19.8999 8.19162 19.1833 7.87495 18.3999C7.55828 17.6166 7.34995 16.7999 7.24995 15.9499Z" fill="#1C6E70"/>
          </g>
        </svg>
      }

    </button>
  `,
  styles: [`
    .btn-forward {
      appearance: none;
      background: transparent;
      border: 0;
      padding: 0;
      line-height: 0;
      cursor: pointer;
    }

    svg path { 
      fill: #000; transition: fill .2s; 
    }

    button:hover svg path { 
      fill: var(--main-color, #0B2C2D); 
    }
  `],
  animations: [
      trigger('rotateOnEnter', [
        transition(':enter', [
          animate('200ms ease-out', keyframes([
            style({ transform: 'rotate(180deg)', offset: 0 }),
            style({ transform: 'rotate(360deg)', offset: 1 })
          ]))
        ])
      ])
    ],
})
export class ForwardIconComponent {
  private timer?: number;
  public  state: 'idle' | 'active' = 'idle';

  playClick() {
    window.clearTimeout(this.timer);
    this.state = 'active';
    this.timer = window.setTimeout(() => {
      this.state = 'idle';
    }, 450);
  }
}